import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';

const deleteAiClipperMedia = async (id: string) => {
  const res = await axiosInstance.delete('/api/video-clipper/delete/' + id);
  return res.data;
};

export const useDeleteAiClipperMedia = () => {
  return useMutation(deleteAiClipperMedia, { onSuccess: (data) => data });
};
